import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/authentication');
  };

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 py-12 md:py-20 lg:py-32">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 md:w-96 md:h-96 lg:w-[32rem] lg:h-[32rem] bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-64 h-64 md:w-96 md:h-96 lg:w-[32rem] lg:h-[32rem] bg-accent rounded-full blur-3xl"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 md:px-5 md:py-2.5 lg:px-6 lg:py-3 bg-primary/10 border border-primary/20 rounded-full mb-6 md:mb-8 lg:mb-10">
            <Icon name="Sparkles" size={16} className="text-primary" />
            <span className="text-xs md:text-sm lg:text-base font-medium text-primary">AI-Powered Code Generation</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-foreground mb-4 md:mb-6 lg:mb-8 leading-tight">
            Transform Ideas into
            <br />
            <span className="bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent">
              Production-Ready Code
            </span>
          </h1>

          <p className="text-base md:text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto mb-8 md:mb-10 lg:mb-12 leading-relaxed">
            Describe your application in natural language and receive complete, downloadable project packages with frontend, backend, database schemas, and authentication—all in seconds.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-5 lg:gap-6">
            <Button
              variant="default"
              size="lg"
              iconName="Rocket"
              iconPosition="left"
              onClick={handleGetStarted}
              className="w-full sm:w-auto min-w-[200px]"
            >
              Generate New App
            </Button>
            <Button
              variant="outline"
              size="lg"
              iconName="Play"
              iconPosition="left"
              className="w-full sm:w-auto min-w-[200px]"
            >
              Watch Demo
            </Button>
          </div>

          <div className="mt-12 md:mt-16 lg:mt-20 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 lg:gap-10 max-w-4xl mx-auto">
            {[
              { value: '10K+', label: 'Projects Generated' },
              { value: '5K+', label: 'Active Users' },
              { value: '99.9%', label: 'Uptime' },
              { value: '< 30s', label: 'Avg Generation Time' }
            ]?.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-1 md:mb-2">
                  {stat?.value}
                </div>
                <div className="text-xs md:text-sm lg:text-base text-muted-foreground">
                  {stat?.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;